var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.813 3.531v1.094h4.375V3.531c0-.11-.11-.219-.22-.219H7.032a.216.216 0 0 0-.218.22ZM5.5 4.625V3.531C5.5 2.711 6.184 2 7.031 2h3.938c.82 0 1.531.71 1.531 1.531v1.094h1.75c.957 0 1.75.793 1.75 1.75v7c0 .984-.793 1.75-1.75 1.75H3.75c-.984 0-1.75-.766-1.75-1.75v-7c0-.957.766-1.75 1.75-1.75H5.5Zm-2.188 5.688v3.062c0 .246.192.438.438.438h10.5a.45.45 0 0 0 .438-.438v-3.063H10.75v.438c0 .492-.41.875-.875.875h-1.75a.864.864 0 0 1-.875-.875v-.438H3.312ZM7.25 9H14.688V6.375a.47.47 0 0 0-.438-.438H3.75a.45.45 0 0 0-.438.438V9H7.25Z"
  })));
};
export default SvgBriefcase;